import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=560c2bcc&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=560c2bcc&prod&lang=css"
import style1 from "./Table.vue?vue&type=style&index=1&id=560c2bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560c2bcc",
  null
  
)

export default component.exports